export const LINKS = {
  bot: 'https://t.me/vocal_cut_bot',
  support: 'https://t.me/ryakimenko',
} as const;
